<template>
  <div class="init">
    <div class="payInfoPage">
      <div class="payment_information addBottom">
        <!-- 倒计时提示 -->
        <div class="payment_tips">
          <span>订单将在 </span>
          <van-count-down :time="time" format="mm:ss" @finish="finish"/>
          <span> 分钟后关闭，请及时完成支付</span>
        </div>
        <div class="payment_container">
          <div class="payment_top">
            <p class="payment_title">缴费金额</p>
            <p class="payment_amount">¥{{ list.price }}</p>
          </div>
        </div>
        <!-- 只读信息 -->
        <div class="payment_info_list">
          <van-field label="订单号" :value="list.order_no" readonly />
          <van-field label="学校名称" :value="list.school_name" readonly />
          <van-field label="缴纳项目" :value="list.expense_name" readonly />
          <van-field label="缴纳年级" :value="list.grades" readonly />
          <van-field label="缴纳班级" :value="list.classes" readonly />
          <van-field label="姓名" :value="list.name" readonly />
          <van-field label="手机号" :value="list.phone" readonly />
        </div>
        <!-- 尾部 -->
        <div id="qrcode" v-show="isShow">
          <p>请使用微信扫一扫～</p>
        </div>
        <div class="payment_footer">
          <div class="ensure_msg">
            <van-radio-group v-model="checked"></van-radio-group>
            <el-checkbox v-model="checked"></el-checkbox>
            <span class="msg_cont">请确认缴费人<span class="red">学校名称、缴费项目、姓名、缴费金额</span>无误</span>
          </div>
          <div class="payment_btn_box" @click="pay" :class="checked == false ? 'disable_btn' : ''">支付</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiSetOreder, apiGetOpenId, apiOrderDetail, apiSchoolWechat, apiSchoolCheckScan } from "@/api/api"
// import VueQr from 'vue-qr'
import {Message} from "element-ui";

export default {
  name: "payInfo",
  components: {
    // VueQr,
  },
  data() {
    return {
      checked: true,
      time: 10 *  60 * 1000,
      list: {},   // 传递过来的数据
      appId:'',
      redirect_url: '',
      order_no: '',
      // appSrc:'',
      // logoSrc:'',
      isShow: false,
      timeFn: null,
    }
  },
  methods:{

    // 自动关闭
    finish(){
      this.$router.back(1)
    },
    // 支付
    pay(){
      var that = this;
      if (this.checked == false) return;
      var opi = localStorage.getItem('opi')
      console.log(opi)
      apiSchoolWechat({
        order_no: this.order_no,
        returnurl: window.location.href,
        openid: opi
      }).then(res => {
        // 判断在微信
        var ua = navigator.userAgent.toLowerCase();
        var isWeixin = ua.indexOf('micromessenger') != -1;
        if(isWeixin){
          this.handleGetDataSucc(res.data)
        }else{
          this.isShow = true;
          // 生成二维码
          new QRCode("qrcode",{
            text: res.data.code_url,  //这个url就是生成二维码的访问路径
            width: 180,
            height: 180,
            render:"canvas",
            colorDark : "#000",   //二维码颜色
            colorLight : "#fff"   //二维码背景色
          });
          this.timeFn = setInterval(function (){
            that.isSuccessfulOrder()
          },2000)
        }
      })
    },

    handleGetDataSucc(res){
      var row = res;
      this.onBridgeReady(row)
      if (typeof WeixinJSBridge == "undefined"){
        if( document.addEventListener ){
          document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(row), false)
        }else if (document.attachEvent){
          document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady(row))
          document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady(row))
        }
      }else{
        console.log('准备调用微信支付')
        this.onBridgeReady(row)
      }
    },
    onBridgeReady(row){
      console.log('调用微信支付WeixinJSBridge')
      console.log(row)
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest', {
          "appId": row.appId,                  // 公众号名称，由商户传入
          "timeStamp": row.timeStamp,          // 时间戳，自1970年以来的秒数
          "nonceStr": row.nonceStr,            // 随机串
          "package": row.package,              // 预支付id
          "signType": row.signType,            // 微信签名方式
          "paySign": row.paySign               // 微信签名
        },
        (res) => {
          if(res.err_msg == "get_brand_wcpay_request:cancel"){

          }else{
            Message.success('支付成功')
            this.$router.push('/payInput?school_id='+ this.list.school_id)
          }
        });
      },
    // 验证是否订单成功
    isSuccessfulOrder(){
      apiSchoolCheckScan({order_no:this.order_no}).then(res=>{
        if(res.code.status == 'SUCCESS'){
          Message.success('支付成功')
          clearInterval(this.timeFn)
          this.$router.push('/index')
        }
      })
    }
  },
  mounted() {
    this.order_no = this.$route.query.order_no;
    // 获取订单详情
    apiOrderDetail({
      order_no: this.order_no
    }).then(res => {
      this.list = res.data;
    })

  },
}
</script>

<style scoped lang="scss">
/deep/ .van-field{
  height: 51px;
}
/deep/ .van-field__control{
  text-align: right;
  font-weight: 600;
}
/deep/ .van-field__label span{
  color: #666;
  font-weight: 600;
}
/deep/ .el-checkbox__inner{
  border-radius: 50%;
}
.init {
  height: 100%;
  .payInfoPage{
    height: 100%;
  }
  .payment_information{
    height: 100%;
    display: flex;
    flex-flow: column;
  }
  .payment_tips{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 8vw;
    font-size: 3.46667vw;
    text-align: center;
    line-height: 8vw;
    background: rgba(250,176,55,.15);
    color: #f4a21d;
  }
  .van-count-down{
    color: #f4a21d;
  }
  .payment_container{
    width: 100%;
    display: flex;
    flex-direction:column;
    .payment_top{
      padding: 8vw 0;
      background: #fff;
      text-align: center;
      margin-bottom: 2.66667vw;
      .payment_title{
        font-size: 3.73333vw;
        line-height: 5.33333vw;
        color: #333333;
        font-weight: 600;
      }
      .payment_amount{
        font-size: 9.6vw;
        font-weight: 600;
        color: #4272ee;
        line-height: initial;
      }
    }
  }
  .payment_info_list{
    flex: 1;
  }
  .payment_footer{
    text-align: center;
    box-sizing: border-box;
    padding: 4vw;
    .ensure_msg{
      margin-bottom: 2.66667vw;
      display: flex;
      align-items: center;
    }
    .am-checkbox{
      width: 4vw;
      height: 4vw;
      vertical-align:middle;
    }
    .disable_btn{
      opacity: .5;
    }
    .payment_btn_box{
      background: #3b74ff;
      border-radius: .53333vw;
      font-size: 4.26667vw;
      line-height: 11.73333vw;
      color: #FFFFFF;
      width: 100%;
    }
    .msg_cont{
      margin-left: 2vw;
      color: #333;
      font-size: 3.2vw;
      font-weight: 600;
      .red{
        color: #de2244;
        font-size: 3.46667vw;
      }
    }
  }
  .codeBox{
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .active{
    background: rgba(0,0,0,.7);
  }
  #qrcode{
    width: 250px;
    height: 250px;
    background: #3b74ff;
    position: absolute;
    top: 35%;
    left: 50%;
    transform: translate(-50%);
    z-index: 999;
    p{
      color: white;
      text-align: center;
      font-size: 14px;
      margin-top: 10px;
    }
  }
  /deep/ #qrcode img{
    margin: 10px auto 10px auto;
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/payInfo/index.vue